import 'css-chunksrc/client/pages/listPage/timestamp/datesPickers/styles.scss';export default {
  "datesWrapper": "_datesWrapper_1ntrp_1",
  "group": "_group_1ntrp_9",
  "title": "_title_1ntrp_16"
};